import { lazy } from 'react';

const Expense = lazy(() => import('../../views/Expense'));
const AddExpense = lazy(() => import('../../views/Expense/components/AddExpensePage'));

const ExpenseRoutes = [
    {
        path: '/expense',
        element: <Expense />
    }, {
        path: '/expense/add',
        element: <AddExpense />
    }, {
        path: '/expense/edit/:id',
        element: <AddExpense />
    }
];

export default ExpenseRoutes;
